<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure>
                          <img :src="$iconFolder + 'company.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Company <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>

                      <notice-published v-model="resource" label-published="Cet événement est actif." label-unpublished="Ce événement est inactif." :dates="true"></notice-published>

                    </header>

                    <main>

                      <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>


                      <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">


                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <!--<form-text label="Slug" v-model="resource.slug" :required="true"></form-text>-->

                                <!-- to do with budget !!! per branch allowed
                                <form-toggle label="Limitation du nombre de participants" v-model="resource.has_subscriptions_limitation"></form-toggle>
                                <div v-show="resource.has_subscriptions_limitation">
                                  <form-number label="Nombre de participants maximum" v-model="resource.total_subscriptions"></form-number>
                                </div>
                                -->

                                <group-line-2>
                                <form-datetime label="Début de l'événement" v-model="resource.start_date"></form-datetime>
                                <form-datetime label="Fin de l'événement" v-model="resource.end_date"></form-datetime>
                                </group-line-2>

                                <form-select-new v-if="branches" label="Succursale" multiple="true" v-model="resource.branches" :options="branches"></form-select-new>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Descriptif'" v-model="resource.translations[client.id].description"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-html :translate-key="'general_conditions'" :translations="resource.translations" :lang="client.id" :label="'Conditions générales'" v-model="resource.translations[client.id].general_conditions"></form-html>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-file :translate-key="'picture_id'" :translations="resource.translations" label='Image' :lang="client.id" v-model="resource.translations[client.id].picture_id" width="200"></form-file>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-file :translate-key="'splash_picture_id'" :translations="resource.translations" label='Splash Screen' :lang="client.id" v-model="resource.translations[client.id].splash_picture_id" width="200"></form-file>
                                  </div>
                                </div>

                                <figure>
                                  <a :href="resource.qr_code" target="_blank"><img :src="resource.qr_code" height="180"/></a>
                                </figure>
                                <a :href="resource.link" target="_blank">{{ resource.link }}</a>

                              </fieldset>

                            </tab>
                          <tab name="Participants">

                            <fieldset>
                              <h3>Détail</h3>
                              <p class="headline"></p>

                              <button @click="exportSubscriptions()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span> Exporter les inscriptions</button>

                              <div class="datagrid">
                                <div class="datagrid-header">
                                  <div>
                                    <div></div>
                                    <div class="left">Lieu</div>
                                    <div class="left">Société</div>
                                    <div class="left">Person details</div>
                                    <div class="left">Email</div>
                                    <div class="left">Date de naissance</div>
                                    <div class="left">Date d'inscription</div>
                                    <div></div>
                                  </div>
                                </div>
                                <div class="datagrid-body">
                                  <div v-for="subscriber in resource.subscriptions" :class="{'is_doublon': subscriber.doublon_id}">
                                    <div><input type="checkbox" v-model="subscriber.checked"/></div>
                                    <div>{{ subscriber.branch ? subscriber.branch.name : "-" }}{{ subscriber.branch ? ", " + subscriber.branch.postal_code : "" }} {{ subscriber.branch ? subscriber.branch.locality : "" }}</div>
                                    <div>{{ subscriber.company }}</div>
                                    <div class="left"><strong>{{ subscriber.firstname }} {{ subscriber.lastname }}</strong></div>
                                    <div>{{ subscriber.email }}</div>
                                    <div>{{ subscriber.birthdate }}</div>
                                    <div><datetime v-model="subscriber.created_at"></datetime></div>
                                    <div></div>
                                  </div>
                                </div>
                              </div>

                            </fieldset>


                          </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import EventService from './EventService.js';
    import Edit from '../../layouts/Edit.vue';
    import BranchService from "../config/branch/BranchService";

    export default {
        extends: Edit,
        components:{
        },
        data () {
            return {
                resource: {

                },
              branches: null,
            }
        },
        mounted: function(){


        },
        methods:{
          exportSubscriptions: function(){
            let fileName = 'subscriptions.xlsx';
            EventService.export(this.resource.id, '', fileName).then(response => {
              if( response && response.data ){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
              }
            });
          },
            resourceLoaded: function(){
              this.setTranslations(['name','description', 'general_conditions', 'picture_id', 'splash_picture_id']);
              this.localesLoaded = true;

              BranchService.all().then(response => {
                this.branches = response.data
                this.isLoading = false;
              });

              /* CONVERT DATES TO LOCAL TIMZONE */
              this.resource.start_date = this.$helpers.utcToLocal(this.resource.start_date, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_date, this.$store.state.scope.timezone).format() : null;
              this.resource.end_date = this.$helpers.utcToLocal(this.resource.end_date, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_date, this.$store.state.scope.timezone).format() : null;
              /*****/

              /* CONVERT DATES TO LOCAL TIMZONE */
              this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
              this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
              /*****/

              this.initialize()
            },
            getResource: function(){
                return EventService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/event/Edit.vue